// const _import =
export default [
  {
    path: '/product',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/index.vue'),
    name: 'product.index',
    meta: {
      title: '设备',
    },
  },
  {
    path: '/product/index/:id?',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/product.vue'),
    name: 'product.index',
    meta: {
      title: '设备列表',
    },
  },
  {
    path: '/product/extra',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/product-extra.vue'),
    name: 'product.extra',
    meta: {
      title: '设备扩展属性',
    },
  },
  {
    path: '/product/extra/add',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/product-extra-add.vue'),
    name: 'product.extra.add',
    meta: {
      title: '设备扩展属性',
    },
  },
  {
    path: '/product/add/:id?',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/product-add.vue'),
    name: 'product.add',
    meta: {
      title: '设备',
    },
  },
  {
    path: '/product/building',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/building.vue'),
    name: 'building.index',
    meta: {
      title: '楼宇列表',
    },
  },
  {
    path: '/product/detail/:id',
    component: () => import(/* webpackChunkName: "product" */ '@/pages/metting/product-detail.vue'),
    name: 'product.detail',
    meta: {
      title: '设备详情',
    },
  }, {
    path: '/product/building',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/building.vue'),
    name: 'building.index',
    meta: {
      title: '楼宇列表',
    },
  },
  {
    path: '/product/building/add/:id?',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/building-add.vue'),
    name: 'building.add',
    meta: {
      title: '楼宇',
    },
  },
  {
    path: '/product/metting/:id?',
    component: () => import(/* webpackChunkName: "metting" */ '@/pages/metting/list.vue'),
    name: 'metting.index',
    meta: {
      title: '会议室列表',
    },
  }
];



// WEBPACK FOOTER //
// ./src/router/metting.js